<template>
  <div class="py-3">
    <div class="bg-white">
      <div v-if="requestPurchaseHasInfo" class="pt-2 pl-2">
        <div class="d-flex align-items-center ml-3 mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Información de Solicitud de Compra
          </div>
        </div>
        <div class="m-2 pt-1">
          <div class="row mb-2">
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Fecha de Compra:
              </p>
              <p class="font-16">
                {{ order?.purchaseRequestDate | date }}
              </p>
            </div>
            <div class="col-12 col-lg-9 mb-3">
              <p class="font-14 text-muted mb-1">
                Sometido por:
              </p>
              <p class="font-16">
                {{ order?.submittedBy | empty }}
              </p>
            </div>
            <div class="col-12 mb-3">
              <p class="font-14 text-muted mb-1">
                Comentario:
              </p>
              <p class="font-16">
                {{ order?.purchaseRequestComment | empty }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="approvalDetailsHasInfo" class="pt-2 pl-2">
        <div class="d-flex align-items-center ml-3 mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Información de Aprobación
          </div>
        </div>
        <div class="m-2 pt-1">
          <div class="row mb-2">
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Fecha de Aprobación:
              </p>
              <p class="font-16">
                {{ order?.purchaseApprovalDate | date }}
              </p>
            </div>
            <div class="col-12 col-lg-9 mb-3">
              <p class="font-14 text-muted mb-1">
                Aprobado por:
              </p>
              <p class="font-16">
                {{ order?.approvedBy | empty }}
              </p>
            </div>
            <div class="col-12 mb-3">
              <p class="font-14 text-muted mb-1">
                Comentario:
              </p>
              <p class="font-16">
                {{ order?.purchaseApprovalComment | empty }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="confirmationDetailsHasInfo" class="pt-2 pl-2">
        <div class="d-flex align-items-center ml-3 mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Información de Confirmación
          </div>
        </div>
        <div class="m-2 pt-1">
          <div class="row mb-2">
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Número de PO:
              </p>
              <p class="font-16">
                {{ order?.purchaseOrderNumber | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Numero de Requisición:
              </p>
              <p class="font-16">
                {{ order?.requisitionNumber | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Fecha de PO:
              </p>
              <p class="font-16">
                {{ order?.purchaseOrderConfirmationDate | date }}
              </p>
            </div>
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Localidad:
              </p>
              <p class="font-16">
                {{ locationName | empty }}
              </p>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12 mb-3">
              <p class="font-14 text-muted mb-1">
                Confirmado por:
              </p>
              <p class="font-16">
                {{ order?.confirmedBy | empty }}
              </p>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12 mb-3">
              <p class="font-14 text-muted mb-1">
                Comentario:
              </p>
              <p class="font-16">
                {{ order?.purchaseOrderConfirmationComment | empty }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <custom-result-not-found
        v-if="
          !requestPurchaseHasInfo &&
            !approvalDetailsHasInfo &&
            !confirmationDetailsHasInfo
        "
        text="No hay Información Disponible."
      />
    </div>
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import IconView from 'icon-view';
import inventoryOrderMaterialsService from '@/services/api/inventoryOrderMaterialsAndEquipments.api';
import CustomResultNotFound from 'custom-result-not-found';
import LocationTypes from '@/utils/constants/inventory/inventoryOrderBookLocationTypes';

export default {
  name: 'TrackedInfo',
  components: {
    SectionTitle,
    IconView,
    CustomResultNotFound,
  },

  props: {
    requestId: {
      type: Number,
    },
  },
  data() {
    return {
      order: {},
      locationTypes: [
        LocationTypes.CSEE,
        LocationTypes.CENTER,
        LocationTypes.SCHOOL,
      ],
    };
  },
  mounted() {
    this.getRequestProgress();
  },
  computed: {
    requestPurchaseHasInfo() {
      return Boolean(
        this.order?.purchaseRequestDate ||
          this.order?.purchaseRequestComment ||
          this.order?.submittedBy
      );
    },
    approvalDetailsHasInfo() {
      return Boolean(
        this.order?.purchaseApprovalDate ||
          this.order?.purchaseApprovalComment ||
          this.order?.approvedBy
      );
    },
    confirmationDetailsHasInfo() {
      return Boolean(
        this.order?.requisitionNumber ||
          this.order?.purchaseOrderNumber ||
          this.order?.purchaseOrderConfirmationComment ||
          this.order?.purchaseOrderConfirmationDate ||
          this.order?.confirmedBy ||
          this.order?.locationTypeId
      );
    },
    locationName() {
      return this.order?.locationTypeId != null
        ? this.locationTypes.find((l) => l.id == this.order?.locationTypeId)
            .name
        : null;
    },
  },
  methods: {
    async getRequestProgress() {
      const { data } = await inventoryOrderMaterialsService.getPurchaseDetails(
        this.requestId
      );
      this.order = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-custom-light-tracked {
  background-color: #f7f7f7;
}
</style>
